export const trustpilotConfig = {
  businessId: '5476fe0400006400057bcaf1',
  locale: 'nb-NO',
  link: 'https://no.trustpilot.com/review/axofinans.no',
};
